import React from "react";
import { twMerge } from "tailwind-merge";

/** A small read-only label on a dish: vegan, spicy, popular... */
const DishTag = ({ className = "", children }) => (
  <span
    className={twMerge(
      "inline-flex items-center rounded-full bg-primary-50 text-primary text-xs font-bold px-2.5 py-1 whitespace-nowrap",
      className
    )}
  >
    {children}
  </span>
);

export default DishTag;
